// Material UI
import { styled, Box } from '@mui/material';
import { TableContainer, Table, TableBody, TableRow, TableCell } from '@mui/material';
import { Card, CardHeader, CardContent } from '@mui/material';

// Components
import RegistrationReview from 'components/comp/CompRegistrationReview';
import { SeatLabel } from 'components/comp/CompComponents';
import { ScrollRestoreContainer } from 'components/ui/layout';
import { SubmitButton } from 'components/ui/buttons';
import { CancelButton } from 'components/ui/buttons';
import { getCountryProfile } from 'utility/countries';


export default function CompReview(props) {
    const { registration, sessionExpired, loading, onCancel, onSubmit } = props;
    const {
        firstName,
        lastName,
        email,
        phone,
        company,
        address,
        city,
        province,
        postalCode,
        country,
    } = props.customer;
    const countryProfile = getCountryProfile(country);

    const products = props.cart.products.filter((t) => t.quantity > 0);
    const bundles = props.cart.bundles.filter((t) => t.quantity > 0);
    const seats = props.cart.seats;

    return (
        <ScrollRestoreContainer>
            <FormContainer>
                <Box mb={4}>
                    <Card>
                        <CardHeader title="Customer" />

                        <CardContent>
                            <TableContainer component={Box}>
                                <Table size="small">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Name</TableCell>
                                            <TableCell align="right">
                                                {firstName} {lastName}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Email</TableCell>
                                            <TableCell align="right">{email}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Phone</TableCell>
                                            <TableCell align="right">
                                                {phone.trim() || '-'}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Company Name</TableCell>
                                            <TableCell align="right">
                                                {company.trim() || '-'}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Address</TableCell>
                                            <TableCell align="right">
                                                {address.trim() || '-'}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>City</TableCell>
                                            <TableCell align="right">
                                                {city.trim() || '-'}
                                            </TableCell>
                                        </TableRow>
                                        {countryProfile.region.mode !== 'hidden' && (
                                            <TableRow>
                                                <TableCell>{countryProfile.region.label}</TableCell>
                                                <TableCell align="right">{province || '-'}</TableCell>
                                            </TableRow>
                                        )}
                                        <TableRow>
                                            <TableCell>{countryProfile.postalCode.label}</TableCell>
                                            <TableCell align="right">
                                                {postalCode.trim() || '-'}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Country</TableCell>
                                            <TableCell align="right">
                                                {countryProfile.label}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                </Box>

                <Box mb={4}>
                    <Card>
                        <CardHeader title="Tickets" />

                        <CardContent>
                            <TableContainer component={Box}>
                                <Table size="small">
                                    <TableBody>
                                        {bundles.map((t) => (
                                            <TableRow key={t.id}>
                                                <TableCell>{t.name}</TableCell>
                                                <TableCell align="right">{t.quantity}</TableCell>
                                            </TableRow>
                                        ))}
                                        {products.map((t) => (
                                            <TableRow key={t.id}>
                                                <TableCell>{t.name}</TableCell>
                                                <TableCell align="right">{t.quantity}</TableCell>
                                            </TableRow>
                                        ))}
                                        {seats.map((t) => (
                                            <TableRow key={t.object.id}>
                                                <TableCell><SeatLabel seat={t} /></TableCell>
                                                <TableCell align="right">1</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                </Box>

                {registration.length > 0 && (
                    <Box mb={4}>
                        <RegistrationReview attendees={registration} />
                    </Box>
                )}

                <ButtonContainer>
                    <CancelButton disabled={loading} onClick={onCancel}>
                        Back
                    </CancelButton>
                    <SubmitButton disabled={loading || sessionExpired} onClick={onSubmit}>
                        Create
                    </SubmitButton>
                </ButtonContainer>
            </FormContainer>
        </ScrollRestoreContainer>
    );
}

const FormContainer = styled(Box)(({ theme }) => ({
    width: theme.breakpoints.values.md,
    paddingBottom: theme.spacing(10),
}));

const ButtonContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
}));
